import { answerLabel } from "../../answer-copy.js";
import { ArrowLeft, Check } from "lucide-react";
import type { QuizQuestion, QuizAnswerKey } from "../config/quizConfig.js";
import type { QuizAnswers } from "@quiz-marketing/contracts";

interface QuestionStepProps {
  question: QuizQuestion;
  answers: Partial<QuizAnswers>;
  step: number;
  advancing: boolean;
  titleRef: React.RefObject<HTMLHeadingElement>;
  onSelect: (id: QuizAnswerKey, value: string) => void;
  onBack: () => void;
}

export function QuestionStep({ question, answers, step, advancing, titleRef, onSelect, onBack }: QuestionStepProps) {
  const options = question.options.map(option => ({...option, label: answerLabel(question.id, option)}));
  return (
    <section className="quiz-content" aria-labelledby="question-title">
      <h1 id="question-title" ref={titleRef} tabIndex={-1}>{question.prompt}</h1>
      <p className="quiz-instructions" id="answer-instructions">{question.instructions}</p>
      <fieldset className="answer-list" aria-describedby="answer-instructions">
        <legend className="sr-only">{question.prompt}</legend>
        {options.map((option) => {
          const selected = answers[question.id] === option.value;
          return (
            <button
              type="button"
              className="answer-option"
              data-selected={selected || undefined}
              aria-pressed={selected}
              aria-disabled={advancing || undefined}
              key={option.value}
              onClick={() => onSelect(question.id, option.value)}
            >
              <span className="answer-marker" aria-hidden="true">{selected && <Check size={18} strokeWidth={3} />}</span>
              <span>{option.label}</span>
            </button>
          );
        })}
      </fieldset>
      <span className="sr-only" role="status">{advancing ? `Respuesta seleccionada: ${options.find(option => option.value === answers[question.id])?.label}. Avanzando.` : ''}</span>
      <div className="quiz-navigation">
        {step > 0 && <button className="quiz-back-button" type="button" disabled={advancing} onClick={onBack}>
          <ArrowLeft size={19} aria-hidden="true" /> Volver
        </button>}
      </div>
    </section>
  );
}
